import { DaoModel } from '@dynameat/models';

export class SaleRateIndexingRule extends DaoModel {
  constructor(guid, percentageIncrement, fixedIncrement, isActive, changedSaleRateGuid,
    referenceSaleRateGuid) {
    super(guid);
    this.percentageIncrement = percentageIncrement;
    this.fixedIncrement = fixedIncrement;
    this.isActive = isActive || false;
    this.changedSaleRateGuid = changedSaleRateGuid || null;
    this.referenceSaleRateGuid = referenceSaleRateGuid || null;
  }

  static toInstance(props = {}) {
    return new SaleRateIndexingRule(
      props.guid,
      props.percentage_increment,
      props.fixed_increment,
      props.is_active,
      props.changed_sale_rate,
      props.reference_sale_rate,
    );
  }

  serialize() {
    return {
      guid: this.guid,
      percentage_increment: this.percentageIncrement,
      fixed_increment: this.fixedIncrement,
      is_active: this.isActive,
      changed_sale_rate: this.changedSaleRateGuid,
      reference_sale_rate: this.referenceSaleRateGuid,
    };
  }
}
